import { ErrorHandler, Injectable } from '@angular/core';
import { ErrorsService } from '@client-services/api';
import { consoleLog } from '@functions/functions';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(
    private readonly errorsService: ErrorsService,
  ) {}

  public handleError(error: unknown): void {
    const errorText = this.getErrorText(error);

    consoleLog(errorText);

    this.errorsService
      .apiErrorsPost({
        appVersionNumber: '3.1.13',
        error: errorText,
      })
      .subscribe({
        error: (reportError: unknown) => {
          console.error('No se pudo registrar el error:', reportError);
        },
      });
  }

  private getErrorText(error: unknown): string {
    if (error instanceof Error) {
      return error.stack || error.message;
    }

    if (typeof error === 'string') {
      return error;
    }

    try {
      return JSON.stringify(error);
    } catch {
      return String(error);
    }
  }
}
